/* src/app/views/dashboard/components/sidebar-nav/nav-item/settings-nav-item/settings-nav-item.component.scss */
/*# sourceMappingURL=settings-nav-item.component.css.map */
